<app-breadcrumb [master]="'Narzędzia'" [parentName]="'ASF360'" [name]="'Posty'"></app-breadcrumb>
<div class="post-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" >

    <mat-form-field class="post-list-filter">
      <mat-label>Nazwa</mat-label>
      <input matInput placeholder="Nazwa" name="contains$postName" [(ngModel)]="initialFilters.contains$postName">
    </mat-form-field>

    <app-dict-tag
      [multiple]="false"
      [tagType]="POST_TAG_TYPE_POST_TYPE"
      [label]="'Typ postu'" class="post-list-filter"
      [(ngModel)]="initialFilters.type" name="type"
    ></app-dict-tag>

    <mat-form-field class="post-list-filter">
      <mat-label>Użytkownik</mat-label>
      <input matInput placeholder="JanKow123" name="username" [(ngModel)]="initialFilters.username">
    </mat-form-field>

    <app-datepicker
      class="post-list-filter"
      label="Data utworzenia od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$createdAt" name="gte$createdAt"
    ></app-datepicker>

    <app-datepicker
      class="post-list-filter"
      label="Data utworzenia do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$createdAt" name="lte$createdAt"
    ></app-datepicker>

    <app-datepicker
      class="post-list-filter"
      label="Data publikacji od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$startAt" name="gte$startAt"
    ></app-datepicker>

    <app-datepicker
      class="post-list-filter"
      label="Data publikacji do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$startAt" name="lte$startAt"
    ></app-datepicker>

    <app-datepicker
      class="post-list-filter"
      label="Data wygaśnięcia do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$endAt" name="gte$endAt"
    ></app-datepicker>

    <app-datepicker
      class="post-list-filter"
      label="Data wygaśnięcia do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$endAt" name="lte$endAt"
    ></app-datepicker>

    <app-dict-permission-tags
      [label]="'Grupy uprawnień'"
      class="post-list-filter"
      [required]="false"
      [multiple]="true"
      [(ngModel)]="initialFilters.permissionTag" name="permissionTag"
    ></app-dict-permission-tags>

    <mat-form-field appearance="standard" class="post-list-filter">
      <mat-label>CTA konkursowe</mat-label>
      <mat-select [(ngModel)]="initialFilters.competitionCta" name="competitionCta">
        <mat-option [value]="null">Wszyscy</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>

  </form>

  <div >
    <div class="add-button">
      <a  [routerLink]="['/asf360/aktualnosci/dodaj']">
        <button  [disabled]="!(userPermissions | async).asf_360.create" (click)="add()"  mat-raised-button color="accent" >
        <mat-icon>add</mat-icon> <span> Dodaj post</span>
      </button>
      </a>
    </div>

    <div class="post-list-buttons">
           <button *ngIf="(userPermissions | async).asf_360.create" (click)="downloadReport()" [disabled]="!(userPermissions | async)?.asf_360.create"
                    mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span>
            </button>

      <button (click)="filter()" mat-raised-button color="primary">
        <mat-icon>search</mat-icon> <span> Szukaj</span>
      </button>


      <button (click)="resetFilters()" mat-raised-button color="warn">
        <mat-icon>delete</mat-icon> <span> Resetuj filtry</span>
      </button>
    </div>

  </div>

  <table mat-table [dataSource]="posts">
    <!-- Position Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> Nagłówek postu</th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['szczegoly', element.uuid]">{{element.postName}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef>  Typ postu</th>
      <td mat-cell *matCellDef="let element">
        {{element.type?.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="tag">
      <th mat-header-cell *matHeaderCellDef> Tagi</th>
      <td mat-cell *matCellDef="let element">
      </td>
    </ng-container>

    <ng-container matColumnDef="user">
      <th mat-header-cell *matHeaderCellDef> Użytkownik</th>
      <td mat-cell *matCellDef="let element">
        {{element.createdBy?.username}}
      </td>
    </ng-container>

    <ng-container matColumnDef="createAt">
      <th mat-header-cell *matHeaderCellDef> Data utworzenia</th>
      <td mat-cell *matCellDef="let element">
        {{element.createdAt | date:'y-MM-dd'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="startAt">
      <th mat-header-cell *matHeaderCellDef>  Data publikacji</th>
      <td mat-cell *matCellDef="let element">
        {{element.startAt | date:'y-MM-dd '}}
      </td>
    </ng-container>

    <ng-container matColumnDef="endAt">
      <th mat-header-cell *matHeaderCellDef>   Data wygaśnięcia </th>
      <td mat-cell *matCellDef="let element">
        {{element.endAt | date:'y-MM-dd'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status</th>
      <td mat-cell *matCellDef="let element">
        <button mat-raised-button [ngClass]="element.status.color + '-button'">{{element.status.name}}</button>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <button [disabled]="!(userPermissions | async).user.read_report" (click)="report(element)" mat-icon-button color="accent"><mat-icon>download</mat-icon></button>
        <button [disabled]="!(userPermissions | async).asf_360.create " (click)="copyPost(element)" mat-icon-button color="primary"><mat-icon>content_copy</mat-icon></button>
        <button *ngIf="(userPermissions | async).asf_360.admin_root ||( element.createdBy.uuid === profile.userId  && (userPermissions | async).asf_360.delete)" [disabled]="!(userPermissions | async).asf_360.admin_root && element.createdBy.uuid !== profile.userId" (click)="delete(element.uuid)" mat-icon-button color="warn"><mat-icon>delete</mat-icon></button>
        <button [disabled]="!(userPermissions | async).user.read_report" *ngIf="element.competitionCta" (click)="downloadReportCTA(element.uuid)" mat-icon-button color="accent" [matTooltip]="'CTA'"><mat-icon>download</mat-icon></button>

      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
